import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import { useGetTokenOrLogout } from "../../../utils/token";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function EditRealTestProduct({
  selectedRowData,
  setSelectedRowData,
}) {
  const [changes, setChanges] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const [testTypeList, setTestTypeList] = useState([]);
  const [testTypeName, setTestTypeName] = useState(null);
  const [subTestTypeList, setSubtestTypeList] = useState([]);
  const [subtestType, setsubtestType] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [countryName, setCountryName] = useState(null);
  const [currency, setcurrency] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    setError,
    reset,
  } = useForm();

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}advisordashboard/gettesttype`)
      .then((response) => response.json())
      .then((data) => {
        setTestTypeList(data);
        const selectedTestType = data?.find(
          (i) => i.id === selectedRowData?.test_type_id?.id
        );
        setTestTypeName(selectedTestType);
        setValue("test_type_id", selectedTestType?.id);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subtesttype`);
        if (response.ok) {
          const data = await response.json();
          const filteredTestType = data.filter(
            (i) => i.test_type_id === testTypeName?.id
          );
          setSubtestTypeList(filteredTestType);
          const selectedSubtestType = filteredTestType?.find(
            (i) => i.id === selectedRowData?.sub_test_type_id?.id
          );
          setsubtestType(selectedSubtestType);
          setValue("sub_test_type_id", selectedSubtestType?.id);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [testTypeName]);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}country`)
      .then((response) => response.json())
      .then((data) => {
        const filteredcountry = data.filter(
          (i) => i.country_name === "India" || i.country_name === "Nepal"
        );
        setCountryList(filteredcountry);
        const selectedCountry = filteredcountry?.find(
          (i) => i.id === selectedRowData?.country_id?.id
        );
        setCountryName(selectedCountry);
        setValue("country_id", selectedCountry?.id);
        setcurrency(selectedCountry?.currency_code);
        setValue("currency", selectedCountry?.currency_code);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  const handleCountryChange = (e, value) => {
    setCountryName(value);
    setValue("country_id", value?.id);
    setcurrency(value?.currency_code);
    setValue("currency", value?.currency_code);
    handleFieldChange("country_id", value?.id);
    handleFieldChange("currency", value?.currency_code);
  };

  const handleFieldChange = (fieldName, value) => {
    setChanges((prevChanges) => ({
      ...prevChanges,
      [fieldName]: value,
    }));

    setSelectedRowData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));

    setValue(fieldName, value); // Update form value
  };

  const onSubmit = async (data) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const requestData = {
        ...changes,
        user_id: parseInt(userId),
      };
      const response = await fetch(
        `${API_ENDPOINT}real-test-product/${selectedRowData?.id}`,
        {
          method: "PUT",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      console.log("result", result);
      if (response.ok) {
        showSnackbar("Product Updated Successfully", "success");

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
      } else if (response.status === 409) {
        showSnackbar("Duplicate Product Name", "error");
      } else {
        showSnackbar(result.error, "error");
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
    }
  };

  return (
    <>
      {isLoading ? (
        <Typography variant="h4">Loading...</Typography>
      ) : (
        <Grid item container spacing={2}>
          <Grid item xs={12}>
            <FormControl
              component="fieldset"
              fullWidth
              error={Boolean(errors.test_category)}
            >
              <Typography variant="h6">
                Type of Test{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>

              <Controller
                name="test_category"
                control={control}
                rules={{ required: "This is a required field" }}
                defaultValue={selectedRowData?.test_category}
                render={({ field }) => (
                  <RadioGroup
                    {...field}
                    row
                    onChange={(e) =>
                      handleFieldChange(
                        "test_category",
                        parseInt(e.target.value)
                      )
                    }
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label="Mock Test (Full Test)"
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio />}
                      label="Module Wise Test"
                    />
                    <FormControlLabel
                      value={3}
                      control={<Radio />}
                      label="Question-Based Test"
                    />
                  </RadioGroup>
                )}
              />

              {errors.test_category && (
                <Typography color="error" variant="caption">
                  {errors.test_category.message}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.test_type_id)}>
              <Typography variant="h6">
                Test Type{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="test_type_id"
                control={control}
                rules={{ required: "This is a required field" }}
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    value={testTypeName}
                    onChange={(e, value) => {
                      setTestTypeName(value);
                      handleFieldChange("test_type_id", value?.id || null);
                      setValue("test_type_id", value?.id || null);
                    }}
                    options={testTypeList}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                    error={Boolean(errors.test_type_id)}
                    helperText={
                      errors.test_type_id && errors?.test_type_id?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>

     {subTestTypeList?.length > 0 && (
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.test_type)}>
              <Typography variant="h6">Sub Test Type </Typography>
              <Controller
                name="sub_test_type_id"
                rules={
  subTestTypeList?.length > 0
    ? { required: "This is a required field" }
    : {}
}
                control={control}
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    value={subtestType}
                    noOptionsText={
                      testTypeName === null
                        ? "Select Test Type First"
                        : testTypeName !== null && subTestTypeList?.length === 0
                        ? "No Test Type Available"
                        : ""
                    }
                    onChange={(e, value) => {
                      setsubtestType(value);
                      handleFieldChange("sub_test_type_id", value?.id || null);
                      setValue("sub_test_type_id", value?.id || null);
                    }}
                    options={subTestTypeList}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                    error={Boolean(errors.sub_test_type_id)}
                    helperText={
                      errors.sub_test_type_id && errors?.sub_test_type_id?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>
     )}

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.product_name)}>
              <Typography variant="h6">
                Product Name{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="product_name"
                control={control}
                rules={{ required: "This is required field" }}
                defaultValue={selectedRowData?.product_name}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                    onChange={(event) =>
                      handleFieldChange("product_name", event.target.value)
                    }
                    error={Boolean(errors.product_name)}
                    helperText={
                      errors.package_name && errors?.product_name?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h6">
                Question Quantity
                {/* <span style={{ color: "red", fontSize: "0.7rem" }}>*</span> */}
              </Typography>
              <Controller
                name="question_quantity"
                control={control}
                // rules={{ required: "This is required field" }} // Add your validation rules here
                defaultValue={selectedRowData?.question_quantity}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    type="number"
                    size="normal"
                    onChange={(event) =>
                      handleFieldChange(
                        "question_quantity",
                        parseInt(event.target.value)
                      )
                    }
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.country_id)}>
              <Typography variant="h6">
                Country{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="country_id"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    disableClearable
                    value={countryName}
                    onChange={handleCountryChange}
                    options={countryList}
                    getOptionLabel={(option) => option.country_name}
                    tooltipContent={(option) => option.country_name}
                    error={Boolean(errors.country_id)}
                    helperText={
                      errors.country_id && errors?.country_id?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>

          {countryName && (
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth error={Boolean(errors.branch_id)}>
                <Typography variant="h6">Currency</Typography>
                <Controller
                  name="currency"
                  control={control}
                  rules={{ required: "This is required field" }} // Add your validation rules here
                  render={({ field }) => (
                    <CustomTextFieldComp
                      {...field}
                      fullWidth
                      size="normal"
                      multiple
                      value={currency}
                      InputProps={{
                        readOnly: true,
                        style: { borderRadius: "10px" },
                      }}
                      onChange={(event) =>
                        handleFieldChange("currency", event.target.value)
                      }
                      error={Boolean(errors.currency)}
                      helperText={errors.currency && errors?.currency?.message}
                    />
                  )}
                />
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.product_amount)}>
              <Typography variant="h6">
                Product Amount{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="product_amount"
                control={control}
                rules={{ required: "This is required field" }}
                defaultValue={selectedRowData?.product_amount}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    type="number"
                    onChange={(event) =>
                      handleFieldChange(
                        "product_amount",
                        parseInt(event.target.value)
                      )
                    }
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                    error={Boolean(errors.product_amount)}
                    helperText={
                      errors.product_amount && errors?.product_amount?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} textAlign="end">
            <Button
              variant="contained"
              size="medium"
              onClick={handleSubmit(onSubmit)}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      )}

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
